export const FORMAT_PHONE_DATA_BY_COUNTRY = {
  az: {
    length: 9,
    mask: 'XX XXX-XX-XX',
    code: '+994',
  },
  am: {
    length: 8,
    mask: 'XX XXX-XXX',
    code: '+374',
  },
  by: {
    length: 9,
    mask: 'XX XXX-XX-XX',
    code: '+375',
  },
  ge: {
    length: 9,
    mask: 'XXX XX-XX-XX',
    code: '+995',
  },
  kz: {
    length: 10,
    mask: 'XXX XXX-XX-XX',
    code: '+7',
  },
  kg: {
    length: 9,
    mask: 'XXX XXX-XXX',
    code: '+996',
  },
  lv: {
    length: 8,
    mask: 'XXXX-XXXX',
    code: '+371',
  },
  lt: {
    length: 8,
    mask: 'XXX XXXXX',
    code: '+370',
  },
  md: {
    length: 8,
    mask: 'XXX X-XX-XX',
    code: '+373',
  },
  ru: {
    length: 10,
    mask: 'XXX XXX-XX-XX',
    code: '+7',
    getPrefix: (rawPhone: string, phoneCode: string) => (rawPhone.startsWith('800') ? '8' : phoneCode),
  },
  tj: {
    length: 9,
    mask: 'XX XXX-XXXX',
    code: '+992',
  },
  uz: {
    length: 9,
    mask: 'XX XXX-XX-XX',
    code: '+998',
  },
  ee: {
    length: 8,
    mask: 'XXXX-XXXX',
    code: '+372',
  },
} as const
